
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 15 12"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#202020","fill-opacity":".47","fill-rule":"evenodd","d":"M3.15 8.25c.342 0 .898.375 2.1.375 1.212 0 1.755-.375 2.1-.375.391 0 .754.117 1.066.312l.806-.807a3.116 3.116 0 00-1.872-.63c-.673 0-.996.375-2.1.375s-1.425-.375-2.1-.375A3.15 3.15 0 000 10.275v.6C0 11.495.504 12 1.125 12h6.054c-.09-.342-.052-.476.02-1.125H1.126v-.6c0-1.116.91-2.025 2.025-2.025zm1.994-7.123A2.252 2.252 0 017.497 3.48a2.258 2.258 0 01-2.142 2.143 2.252 2.252 0 01-2.353-2.354 2.258 2.258 0 012.142-2.142zm.104 5.623a3.374 3.374 0 003.377-3.377C8.622 1.537 7.087.003 5.252 0a3.374 3.374 0 00-3.377 3.377c.002 1.835 1.537 3.37 3.373 3.373zm9.588-.448l-.889-.888a.562.562 0 00-.792 0l-.98.98 1.683 1.68.98-.98a.564.564 0 00-.002-.792zm-6.424 3.853l-.16 1.43a.373.373 0 00.413.412l1.427-.159 3.232-3.232-1.68-1.68-3.232 3.23z"}})])
          )
        }
      }
    